import React from "react";
import { Button, Col, List, Row } from "antd";
import { IStore } from "../../../core/model/runtime/state/Store";
import { TLegalViewPresentationModel } from "../../presenter/model/LegalViewPresentationModel";

import { PlusOutlined } from "@ant-design/icons";
import Title from "antd/lib/typography/Title";
import Text from "antd/lib/typography/Text";
import { IUser } from "../../../user/model/User";
import LegalViewListItem from "./LegalViewListItem";
export interface LegalViewListProps {
  translate: any;
  loaders: any;
  store: IStore;
  legalViewList: TLegalViewPresentationModel[];
  createNewLegalView(): void;
  showLegalViewDetails(id: number): void;
  user?: IUser;
}
const LegalViewList: React.FC<LegalViewListProps> = (
  props: LegalViewListProps
) => {
  const {
    translate,
    legalViewList,
    createNewLegalView,
    showLegalViewDetails,
    user
  } = props;
  return (
    <div>
      <Row className={"search-result"}>
        <Col xs={24} sm={24}>
          <Title level={4}>
            {translate("editors.legal_views.create_modal_title")}
          </Title>
          <Text>Prikazani su svi unosi.</Text>
        </Col>
      </Row>
      <Row
        className={"datagrid-header"}
        style={
          user?.isUser()
            ? { display: "none" }
            : { textAlign: "right", paddingTop: 20 }
        }
      >
        <Col
          sm={24}
          style={
            user?.isUser()
              ? { display: "none" }
              : { textAlign: "right", paddingTop: 20 }
          }
        >
          <Button
            style={{ textAlign: "right" }}
            className="datagrid-add-btn"
            type={"primary"}
            icon={<PlusOutlined />}
            onClick={() => createNewLegalView()}
          >
            {translate("editors.legal_views.add_new_text")}
          </Button>
        </Col>
      </Row>
      <List
        size="large"
        locale={{
          emptyText: translate("data_grid.empty_text")
        }}
        pagination={{
          hideOnSinglePage: legalViewList.length < 10,
          pageSize: 10,
          showSizeChanger: true,
          total: legalViewList.length,
          position: "top",
          showTotal: (total, range) => (
            <Text style={{ position: "absolute", left: 0 }}>{`${translate(
              "data_grid.pagination.showing"
            )} ${range[0]} ${translate("data_grid.pagination.to")} ${
              range[1]
            } ${translate("data_grid.pagination.total")} ${total}`}</Text>
          )
        }}
        dataSource={legalViewList}
        renderItem={(item) => (
          <LegalViewListItem
            item={item}
            translate={translate}
            showLegalViewDetails={showLegalViewDetails}
          />
        )}
      />
    </div>
  );
};
export default LegalViewList;
